/**
 * Which backend board produced a turn of the unified assistant.
 *
 * - `attendance` — the attendance-query board (live school data, v2 payloads).
 * - `faq` — the document/knowledge-base board (how-to answers from the user manual).
 *
 * Stamped on bot messages and history turns FROM THE RESPONSE (`capability`), never guessed
 * before the request goes out: the backend routes every turn itself from the full history and
 * ignores any board the client names. On the client the source only drives UI affordances
 * (e.g. the "Create a support ticket" action under support answers).
 */
export type AssistantSource = 'attendance' | 'faq'

/**
 * The board a registered capability id belongs to. `attendance.*` is the data board;
 * `support.*` (manual, walkthrough) is the knowledge base. Unknown or missing ids give `null`
 * so the caller can fall back on what the answer actually carried.
 */
export function assistantSourceForCapability(
  capabilityId: string | null | undefined
): AssistantSource | null {
  if (!capabilityId) return null
  if (capabilityId.startsWith('attendance.')) return 'attendance'
  if (capabilityId.startsWith('support.')) return 'faq'
  return null
}
